import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiRadio } from '@taiga-ui/core';
import { DeviceDetectorService } from '@core/services/device-detector/device-detector.service';
import { OutkeepPermissionService } from '@core/services/permission/outkeep-permission.service';
import { RequestsApiService } from '@core/services/request/requests-api.service';
import { RequestStatusesService } from '@core/services/request/request-statuses.service';
import { Nullable } from '@core/helpers';
import { RequestStatus } from '@core/types';
import { FormsModule } from '@angular/forms';
import { TuiButton } from '@taiga-ui/core';
import { Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'x-change-status-group-actions-view',
  imports: [CommonModule, TuiRadio, FormsModule, TuiButton, TranslatePipe],
  templateUrl: './change-status-group-actions-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeStatusGroupActionsViewComponent {
  $viewObserver = input.required<Subject<never>>({
    alias: 'viewObserver',
  });
  private readonly requestsApiService = inject(RequestsApiService);
  private readonly permissionService = inject(OutkeepPermissionService);
  private readonly requestStatusesService = inject(RequestStatusesService);
  readonly deviceService = inject(DeviceDetectorService);
  private readonly destroyRef = inject(DestroyRef);

  readonly requestStatuses$ = this.requestsApiService.getRequestStatuses$();
  readonly canLogistChangeRequestStatus$ =
    this.permissionService.canLogistChangeRequestStatus$;

  public newStatusValue: Nullable<RequestStatus> = null;

  public changeStatus() {
    if (this.newStatusValue === null) {
      return;
    }

    this.requestStatusesService
      .applyGroupStatus(this.newStatusValue, this.$viewObserver())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.newStatusValue = null;
        this.$viewObserver().complete();
      });
  }
}
